export default "__VITE_ASSET__K5$gbBF2__"